/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION'
}


export function instanceOfInternalApiEntityType(value: any): boolean {
    for (const key in InternalApiEntityType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiEntityType, key)) {
            if (InternalApiEntityType[key as keyof typeof InternalApiEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiEntityTypeFromJSON(json: any): InternalApiEntityType {
    return InternalApiEntityTypeFromJSONTyped(json, false);
}

export function InternalApiEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntityType {
    return json as InternalApiEntityType;
}

export function InternalApiEntityTypeToJSON(value?: InternalApiEntityType | null): any {
    return value as any;
}

export function InternalApiEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiEntityType {
    return value as InternalApiEntityType;
}

